import React, { memo, ReactNode } from 'react';
import { green } from '@mui/material/colors';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

interface Props {
  name: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  icon?: JSX.Element;
  children?: ReactNode;
  fullWidth?: boolean;
}

const GreenButtonStyling = styled(Button)(({ theme }) => ({
  backgroundColor: green[600],
  '&:hover': {
    backgroundColor: green[500],
  },
}));

const GreenButton = memo(
  ({ name, onClick, disabled = false, icon, fullWidth = false }: Props) => {
    return (
      <GreenButtonStyling
        variant='contained'
        onClick={onClick}
        disabled={disabled}
        fullWidth={fullWidth}
      >
        {icon} {name}
      </GreenButtonStyling>
    );
  }
);

export default GreenButton;
